<template>
    <div class="bizcomp-fund-market white-bg">
        <div class="fund-types">
            <div style="display: flex; align-items: center">
                <span style="color: #666666">基金类型：</span>
                <el-radio-group v-model="activeType" size="mini">
                    <el-radio-button
                        v-for="item in fundShowTypes"
                        :key="item.val"
                        :label="item.val"
                    >
                        {{ item.text }}
                    </el-radio-button>
                </el-radio-group>
            </div>
            <div class="fund-search">
                <el-autocomplete
                    v-model="searchText"
                    popper-class="my-autocomplete"
                    placeholder="基金品代码/名称"
                    class="input-search"
                    size="small"
                    :fetch-suggestions="querySearchAsync"
                    v-on:select="handleSelect"
                >
                    <template slot-scope="{ item }">
                        <div class="name">
                            {{ item.value }}
                        </div>
                    </template>
                    <el-button
                        slot="suffix"
                        icon="el-icon-search"
                        class="search-icon"
                        type="text"
                        size="small"
                        v-on:click="searchFund"
                    />
                </el-autocomplete>
            </div>
        </div>
        <fund-list
            :has-load="hasLoad"
            :fund-info="fund"
            :all-page="allPage"
            :is-public="isPublic"
            :lock="lock"
            :userinfo="userInfo"
            v-on:new-fund="newFund"
            v-on:fund-continue="fundBuy"
        />
        <fund-risk-filter :quick-buy="true" :qryall="ismatch" v-on:qry-change="qryChange" />
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import fundList from "@/components/fund/buyFundList";
import fundRiskFilter from "@/components/form/fundRiskFilter";
import fundApi from "@/api/fund";

export default {
    name: "FundMarket",
    components: {
        fundList,
        fundRiskFilter
    },
    mixins: [mixin],
    props: {
        isPublic: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            userInfo: {}, // 用户信息
            ismatch: "0", // 是否只看风险匹配
            searchText: "", // 搜索文本内容
            fund: [], // 基金信息
            queryFind: null, // 定时器
            allPage: "0", // 所有数据条数
            pagecount: 10, // 分页条数
            pageoffset: 1, // 起始页
            fundShowTypes: [
                { val: "", text: "全部" },
                { val: "1", text: "股票型" },
                { val: "3", text: "混合型" },
                { val: "2", text: "指数型" },
                { val: "6", text: "QDII" },
                { val: "7", text: "FOF" },
                { val: "13", text: "商品期货ETF" },
                { val: "4", text: "债券型" },
                { val: "5", text: "货币型" }
            ],
            activeType: "", // 基金类型
            hasLoad: false, // 是否已经查询数据
            lock: false
            // 是否声明可见
        };
    },
    watch: {
        searchText(val, from) {
            if (from.length > 0 && val == "") {
                this.searchFund();
            }
        },
        activeType(val) {
            this.searchFund();
        }
    },
    created() {
        this.$store.commit("updateLoadFund", false);
        const info = this.$cache.getUser();
        if (info.professionflag == "0") {
            this.ismatch = info.ismatch || "1";
        }
        this.riskList = this.$cache.getDict("110143");
        if (!this.isPublic && this.$cache.getBinded()) {
            // 高端理财列表且已开户更新用户信息 判断是否做过声明 风测
            this.$cache.refreshUser(() => {
                this.userInfo = this.$cache.getUser();
                this.ismatch = this.userInfo.ismatch || "1";
                this.authentication();
                this.doAction();
            });
        } else {
            this.doAction();
        }
    },
    methods: {
        // 列表中"认证可见"是否翻转展示实际数据，已登录+已声明+已测评 。即完成投资者声明+完成测评 才能看到认证可见的部分
        authentication() {
            if (
                this.$util.belongHx() &&
                !this.isPublic &&
                (this.userInfo.riskexpired !== "0" || this.userInfo.disclaimersignflag !== "1")
            ) {
                this.lock = true;
            } else {
                this.lock = false;
            }
        },
        // 处理基金适当性信息
        fundBuy(way, val) {
            // 处理购买现金宝基金跳转
            if (this.xjbCode && this.xjbCode.indexOf(val.fundcode) > -1 && way === "20,22") {
                this.$router.push({ name: "currencycharge", query: { fundcode: val.fundcode } });
                return;
            }
            // 普通购买/定投
            let _url = "";
            if (way === "20,22") {
                _url = "buyfund";
                val.proto = "buy";
            } else if (way === "59") {
                _url = "generalbuy";
                val.proto = "plan";
            }
            this.$util.fundRiskCheck(this, val, (res) => {
                if (res) {
                    const _x = Object.assign({}, res, { way: way });
                    sessionStorage.setItem(_url, JSON.stringify(_x));
                    this.$router.push({ name: _url, query: { fundcode: res.fundcode } });
                }
            });
        },
        // 改变风险过滤规则
        qryChange(val) {
            this.ismatch = val;
            this.pageoffset = 1;
            this.doAction();
        },
        // 搜索基金
        searchFund() {
            this.pageoffset = 1;
            this.doAction(this.searchText);
        },
        // 获取下拉列表数据
        querySearchAsync(queryString, cb) {
            this.pageoffset = 1;
            let _cbArr = [];
            this.doAction(queryString, (res) => {
                // res.forEach((item, index) => {
                //     let _x = {};
                //     _x.value = item.fundname + "(" + item.fundcode + ")";
                //     _x.id = item.fundcode;
                //     _x.index = index;
                //     _cbArr.push(_x);
                // });
            });
            cb(_cbArr);
        },
        // 选中建议项
        handleSelect() {
            if (this.searchText.indexOf("(") != -1) {
                this.searchText = this.searchText.slice(0, this.searchText.indexOf("("));
            }
            this.pageoffset = 1;
            this.doAction();
        },
        // 获取新一页数据
        newFund(val) {
            this.pageoffset = val;
            this.doAction();
        },
        // 获取基金信息
        async getFund(val, cb) {
            const _this = this;
            const _x = {
                fundclass: this.isPublic ? "0" : "1",
                fundshowtype: Number(this.activeType) == 0 ? "" : this.activeType,
                ismatch: this.ismatch,
                issale: this.isPublic ? "" : "1",
                valuagrbuystate: "",
                keyword: val || (this.searchText ? this.searchText : ""),
                pagesize: cb ? 20 : this.pagecount,
                pagenum: val ? 1 : this.pageoffset,
                tradeflag: "1" // 是否查询允许交易的产品 0-不限制 1-限制
            };
            const res = await fundApi.getFundLists(_x);
            this.hasLoad = true;
            if (res.data) {
                this.$store.commit("updateLoadFund", true);
                if (this.pageoffset == 1) {
                    this.allPage = "0";
                }
                _this.fund = res.data.list;
                // 记录过滤状态
                const info = _this.$cache.getUser();
                info.ismatch = _this.ismatch;
                _this.$store.dispatch("setInfo", info);
                _this.allPage = res.data.total.toString();
                if (cb) {
                    cb.call(_this, res.data.list);
                }
            }
        },
        // 对基金频繁查询请求做处理
        doAction(val, cb) {
            const _this = this;
            if (cb) {
                val = this.$util.filterCode(val);
                this.searchText = val;
                if (val.length < 1) {
                    cb.call(this, []);
                    return false;
                }
            }
            clearTimeout(this.queryFind);
            this.queryFind = setTimeout(function () {
                _this.getFund(val, cb);
            }, 500);
        },
        // 切换类型tab
        handleClick(target) {
            this.pageoffset = 1;
            this.doAction();
        }
    }
};
</script>

<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-fund-market {
    margin-right: 20px;
    .fund-types {
        display: flex;
        padding: 0 0 20px;
        align-items: center;
        justify-content: space-between;
        .el-radio-button--mini .el-radio-button__inner {
            font-size: 14px;
            color: #666666;
            border: none;
        }
        .el-radio-button__orig-radio:checked + .el-radio-button__inner {
            background: transparent;
            color: #e60012;
            box-shadow: none;
        }
        .fund-search {
            padding: 0;
            .input-search {
                width: 290px;
                vertical-align: middle;
                .search-icon {
                    margin: 0 5px;
                    padding: 12.5px 0;
                    color: #e60012;
                }
                .el-input__inner {
                    height: 40px;
                    border-bottom-right-radius: 0;
                    border-top-right-radius: 0;
                }
                .el-input-group__append {
                    background-color: $color-a;
                    color: $text-color6;
                    font-size: $f20;
                    border-color: $color-a;
                    padding: 0 10px;
                }
            }
        }
    }
}
.white-bg {
    background: #ffffff;
    padding: 20px;
}
</style>
